import React from "react";
import clsx from "clsx";

import { IContent } from "../../state";

import styles from "./OneAnswerContents.module.scss";

type OneAnswerContentsProps = {
  contents: IContent[];
  hideBorder?: boolean;
};

export const OneAnswerContents: React.FC<OneAnswerContentsProps> = ({
  contents,
  hideBorder = false,
}) => {
  return (
    <div className={styles.body}>
      {contents.map(content => (
        <div
          key={content.question_id}
          className={clsx(styles.content, hideBorder && styles.noBorder)}
          style={{ order: content.layout_order }}
        >
          <p className={styles.statement}>{content.statement}</p>
          <p className={styles.value}>{content.content}</p>
        </div>
      ))}
    </div>
  );
};

export default OneAnswerContents;
